import React from 'react';
import './Calendar.css';

// Map of YYYY-M-D -> {type, label}
// Types map to CSS classes: deadline, training, service, location
const events = {
  // May
  '2026-5-16': { type: 'deadline', label: 'Application Deadline' },
  '2026-5-31': { type: 'deadline', label: 'Welcome Notes Sent' },

  // June
  '2026-6-12': { type: 'training', label: 'Virtual Training' },
  '2026-6-15': { type: 'service' },
  '2026-6-16': { type: 'service' },
  '2026-6-17': { type: 'service' },
  '2026-6-18': { type: 'service' },
  '2026-6-20': { type: 'location', label: 'All to 6611 Guess Rd, Durham' },
  '2026-6-22': { type: 'service' },
  '2026-6-23': { type: 'service' },
  '2026-6-24': { type: 'service' },
  '2026-6-25': { type: 'service' },
  '2026-6-26': { type: 'service' },
  '2026-6-29': { type: 'service' },
  '2026-6-30': { type: 'service' },

  // July
  '2026-7-1': { type: 'service' },
  '2026-7-2': { type: 'service' },
  '2026-7-6': { type: 'service' },
  '2026-7-7': { type: 'service' },
  '2026-7-8': { type: 'service' },
  '2026-7-9': { type: 'service' },
  '2026-7-10': { type: 'service' },
  '2026-7-11': { type: 'service' },
  '2026-7-12': { type: 'location', label: 'All to 2102 S Alston Ave, Durham' },
  '2026-7-13': { type: 'service' },
  '2026-7-14': { type: 'service' },
  '2026-7-15': { type: 'service' },
  '2026-7-16': { type: 'service' },
  '2026-7-20': { type: 'service' },
  '2026-7-21': { type: 'service' },
  '2026-7-22': { type: 'service' },
  '2026-7-23': { type: 'service' },
  '2026-7-24': { type: 'service' },
  '2026-7-27': { type: 'service' },
  '2026-7-28': { type: 'service' },
  '2026-7-29': { type: 'service' },
  '2026-7-30': { type: 'service' },
  '2026-7-31': { type: 'service' },

  // August
  '2026-8-3': { type: 'service' },
  '2026-8-4': { type: 'service' },
  '2026-8-5': { type: 'service' },
  '2026-8-6': { type: 'service' },
};

const MONTHS = [
  { name: 'May', number: 5, year: 2026 },
  { name: 'June', number: 6, year: 2026 },
  { name: 'July', number: 7, year: 2026 },
  { name: 'August', number: 8, year: 2026 },
];

const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const MonthCalendar = ({ name, number, year }) => {
  const firstDay = new Date(year, number - 1, 1).getDay();
  const daysInMonth = new Date(year, number, 0).getDate();

  const cells = [];
  for (let i = 0; i < firstDay; i++) {
    cells.push(<div key={`empty-${i}`} className="cal-cell cal-empty" />);
  }
  for (let day = 1; day <= daysInMonth; day++) {
    const key = `${year}-${number}-${day}`;
    const event = events[key];
    const className = `cal-cell cal-day${event ? ` cal-${event.type}` : ''}`;
    cells.push(
      <div
        key={day}
        className={className}
        title={event && event.label ? event.label : ''}
      >
        {day}
      </div>
    );
  }

  return (
    <div className="cal-month">
      <h3 className="cal-month-title">
        {name} <span className="cal-month-year">{year}</span>
      </h3>
      <div className="cal-grid">
        {DAY_LABELS.map((d) => (
          <div key={d} className="cal-day-label">{d}</div>
        ))}
        {cells}
      </div>
    </div>
  );
};

const Calendar = () => {
  return (
    <main className="calendar-page">
      <div className="calendar-container">
        <section className="calendar-hero">
          <h1 className="calendar-title">Youth Supporting Roots</h1>
          <p className="calendar-subtitle">Generations Working Together</p>
        </section>

        <h2 className="section-title">2026 Program Calendar</h2>

        <div className="calendar-intro">
          <p>
            Below is the schedule for our Summer 2026 program, which runs from
            June 12th to August 4th, 2026. Service weeks bring youth participants
            and chaperones together at local food pantries and community sites.
          </p>
        </div>

        <div className="legend">
          <h3 className="legend-title">Key</h3>
          <div className="legend-items">
            <span className="legend-item">
              <span className="legend-swatch swatch-deadline" /> Important Date
            </span>
            <span className="legend-item">
              <span className="legend-swatch swatch-training" /> Training
            </span>
            <span className="legend-item">
              <span className="legend-swatch swatch-service" /> Service Day
            </span>
            <span className="legend-item">
              <span className="legend-swatch swatch-location" /> Special Location
            </span>
          </div>
        </div>

        <div className="months-grid">
          {MONTHS.map((m) => (
            <MonthCalendar
              key={m.name}
              name={m.name}
              number={m.number}
              year={m.year}
            />
          ))}
        </div>

        <div className="schedule-detail">
          <h3 className="schedule-title">Schedule Details</h3>
          <ul className="schedule-list">
            <li><strong>May 16, 2026</strong> — Application deadline (3rd Saturday of May, 11:59 PM)</li>
            <li><strong>May 31, 2026</strong> — Welcome notes &amp; 4-week schedule sent to selected participants</li>
            <li><strong>June 12, 2026</strong> — Virtual Training (program start)</li>
            <li><strong>June 15 – June 18</strong> — Service week</li>
            <li><strong>June 20</strong> — All to 6611 Guess Road, Durham, NC</li>
            <li><strong>June 22 – June 26</strong> — Service week</li>
            <li><strong>June 29 – July 2</strong> — Service week</li>
            <li><strong>July 6 – July 11</strong> — Service week</li>
            <li><strong>July 12</strong> — All to 2102 S Alston Ave, Durham, NC</li>
            <li><strong>July 13 – July 16</strong> — Service week</li>
            <li><strong>July 20 – July 24</strong> — Service week</li>
            <li><strong>July 27 – July 31</strong> — Service week</li>
            <li><strong>August 3 – August 6</strong> — Final service week</li>
          </ul>
        </div>
      </div>
    </main>
  );
};

export default Calendar;
